/* ==========================================================================
   FRØYA GOURMET — Varsel når noe legges i kurven (v2, 03.11.2026)

   Lytter på «cart:updated» (produktkortene, og produktsiden via
   froya-kurvtall.js) og viser en tydelig bekreftelse.
   v2: varselet henger RETT UNDER kurv-ikonet i toppen, med en liten pil opp
   mot kurven — på mobil også (før lå det nederst på skjermen, langt fra
   kurven). Det følger ikonet mens headeren krymper ved scrolling. Hele
   varselet er en lenke til handlekurven («Gå til handlekurven →»), står
   4 s (pause når musa er over), og kommer inn idet det svevende varebildet
   lander i kurven (froya-kurvtall.js). Varetittelen escapes.
   window.fgVisVarsel(html) virker som før (uten lenke).
   ========================================================================== */
(function () {
  'use strict';

  var wrap = null;
  var loop = 0;
  var mqRo = window.matchMedia('(prefers-reduced-motion: reduce)');
  var VIS_MS = 4000;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fåWrap() {
    if (wrap) return wrap;
    wrap = document.createElement('div');
    wrap.className = 'fg-toast-wrap';
    wrap.setAttribute('aria-live', 'polite');
    wrap.setAttribute('role', 'status');
    document.body.appendChild(wrap);
    return wrap;
  }

  /* Plasser varselet under kurv-ikonet, med pila midt på ikonet. */
  function plasser() {
    if (!wrap) return;
    var k = document.querySelector('.fg-header__cart');
    var r = k ? k.getBoundingClientRect() : null;
    if (!r || !r.width) return;
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var hoyre = Math.max(12, Math.round(vw - r.right - 2));
    wrap.style.top = Math.round(r.bottom + 12) + 'px';
    wrap.style.right = hoyre + 'px';
    wrap.style.setProperty('--fg-toast-pil', Math.max(16, Math.round(vw - hoyre - (r.left + r.width / 2))) + 'px');
  }

  function folg() {
    cancelAnimationFrame(loop);
    (function steg() {
      plasser();
      if (wrap && wrap.childElementCount) loop = requestAnimationFrame(steg);
    })();
  }

  function visVarsel(tekst, tilKurv) {
    var w = fåWrap();
    var el = document.createElement(tilKurv ? 'a' : 'div');
    el.className = 'fg-toast' + (tilKurv ? ' fg-toast--kurv' : '');
    if (tilKurv) el.href = '/cart';
    el.innerHTML = '<span class="fg-toast__icon" aria-hidden="true">✓</span>' +
      '<span class="fg-toast__text">' + tekst +
      (tilKurv ? '<span class="fg-toast__cta">Gå til handlekurven <span aria-hidden="true">→</span></span>' : '') +
      '</span>';
    w.appendChild(el);
    folg();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-in'); });
    });

    var timer = 0;
    function ut() {
      el.classList.remove('is-in');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 350);
    }
    function start(ms) { clearTimeout(timer); timer = setTimeout(ut, ms); }
    start(VIS_MS);
    el.addEventListener('mouseenter', function () { clearTimeout(timer); });
    el.addEventListener('mouseleave', function () { start(1600); });

    /* Ikke la varsler hope seg opp ved rask klikking. */
    var alle = w.querySelectorAll('.fg-toast');
    if (alle.length > 2) alle[0].parentNode.removeChild(alle[0]);
  }

  window.fgVisVarsel = function (tekst) { visVarsel(tekst, false); };

  document.addEventListener('cart:updated', function (e) {
    var d = e.detail || {};
    if (d.fgStille) return;
    var navn = d.itemTitle;
    var tekst = navn
      ? '<b>' + esc(navn) + '</b> er lagt i handlekurven'
      : 'Lagt i handlekurven – <b>' + (d.itemCount != null ? esc(d.itemCount) : '') + '</b> varer totalt';
    /* Kommer inn idet varebildet lander i kurven (froya-kurvtall.js). */
    setTimeout(function () { visVarsel(tekst, true); }, mqRo.matches ? 0 : 560);
  });
})();

/* ==========================================================================
   FRØYA GOURMET — Abonnement-widget: SAMME TALL, SAMME ENHET (v3, okt 2026)

   Problemet (26.10.2026): toppen av produktsiden viser «589,20 kr/kg», men
   abonnementsraden viste «1 252,05 kr» (eskepris) og éngangsraden viste
   ingen pris — tre tall i to enheter som ikke kunne sammenlignes.
   Nå, begge radene i ESKEPRIS (samme enhet som «Eske 2,5 kg · 1 473 kr»):
     Engangskjøp                              1 473 kr
     ABONNER OG SPAR 10 %          1 473 kr   1 325,70 kr
     530,28 kr/kg · du sparer 147,30 kr
   Den siste linja regnes ut fra abonnementsprisen og eskevekten som står
   under kiloprisen, så den alltid er direkte sammenlignbar med toppen.

   v4 (26.10.2026) KORTE FREKVENSKNAPPER: planene heter i appen
   «Lever hver 2. uke, 10 % rabatt». Rabatten står allerede i overskriften
   («Abonner og spar 10 %»), så knappene viser bare «Hver 2. uke».
   Planenes navn i appen er uendret (de vises i kassen og på ordren).

   Shopify Subscriptions-appen skriver prisen på éngangsraden OG på hver
   frekvensrad. Frekvensradenes pris skjules i assets/froya-abonnement.css;
   her flyttes abonnementsprisen inn i overskriften, NOK → kr, «,00» fjernes,
   «Éngangskjøp» (skrivefeil i appens tekst) rettes til «Engangskjøp», og et
   klikk på overskriften velger første frekvens. Appen tegner widgeten på nytt
   ved variantbytte, derfor en MutationObserver (debounced).
   Feiler noe her, står appens egen widget urørt — kjøpet påvirkes aldri.
   ========================================================================== */
(function () {
  'use strict';

  function tilKr(tekst) {
    return tekst
      .replace(/\s*NOK\s*$/, ' kr')
      .replace(/,00 kr$/, ' kr')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tall(tekst) {
    var s = String(tekst || '').replace(/[^\d,]/g, '').replace(',', '.');
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }

  function fmt(n) {
    var d = n.toFixed(2).split('.');
    var h = d[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return d[1] === '00' ? h : h + ',' + d[1];
  }

  /* «Eske 2,5 kg ·» under kiloprisen → { mengde: 2.5, enhet: 'kg' } */
  function eske() {
    var del = document.querySelector('.fg-pris--side .fg-pris__del');
    var m = del && /Eske\s+([\d.,]+)\s*([^\s·]+)/.exec(del.textContent);
    if (!m) return null;
    var q = tall(m[1]);
    return q ? { mengde: q, enhet: m[2] } : null;
  }

  /* v4: «Lever hver 2. uke, 10 % rabatt» → «Hver 2. uke» */
  function kortFrekvens(tekst) {
    return tekst
      .replace(/\s*,\s*\d+(?:[.,]\d+)?\s*%\s*(?:rabatt|off)\s*$/i, '')
      .replace(/^(\s*)Lever hver/, '$1Hver');
  }

  function ryddFrekvenser(liste) {
    if (!document.createTreeWalker) return;
    var w = document.createTreeWalker(liste, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (n.parentElement && n.parentElement.closest('.in_widget_price')) continue;
      var ny = kortFrekvens(n.nodeValue);
      if (ny !== n.nodeValue) n.nodeValue = ny;
    }
  }

  function rydd() {
    var blokker = document.querySelectorAll('.shopify_subscriptions_app_block');
    for (var b = 0; b < blokker.length; b++) {
      var blokk = blokker[b];

      var priser = blokk.querySelectorAll('.in_widget_price');
      for (var p = 0; p < priser.length; p++) {
        if (/NOK/.test(priser[p].textContent)) priser[p].textContent = tilKr(priser[p].textContent);
      }

      /* Skrivefeil i appens tekst: «Éngangskjøp» */
      var tekster = blokk.querySelectorAll('.one_time_purchase_option_app_block span');
      for (var t = 0; t < tekster.length; t++) {
        if (/^\s*Éngangskjøp\s*$/.test(tekster[t].textContent)) tekster[t].textContent = 'Engangskjøp';
      }

      var engangPris = blokk.querySelector('.subscription_group:not(.fg-abo-gruppe) .in_widget_price');
      var engang = engangPris ? tilKr(engangPris.textContent) : '';

      var grupper = blokk.querySelectorAll('.subscription_group');
      for (var g = 0; g < grupper.length; g++) {
        var gruppe = grupper[g];
        var liste = gruppe.querySelector('.group_list');
        if (!liste) continue;
        var hode = gruppe.querySelector(':scope > .title_and_price_wrapper');
        if (!hode) continue;

        gruppe.classList.add('fg-abo-gruppe');
        ryddFrekvenser(liste);

        var valgt = liste.querySelector('input:checked');
        var kilde = valgt ? valgt.closest('li') : liste.querySelector('li');
        var pris = kilde && kilde.querySelector('.in_widget_price');

        var el = hode.querySelector('.fg-abo-pris');
        if (!el) {
          el = document.createElement('span');
          el.className = 'fg-abo-pris';
          hode.appendChild(el);
        }
        var ny = pris ? tilKr(pris.textContent) : '';
        var html = (engang && ny && engang !== ny ? '<s class="fg-abo-for">' + engang + '</s>' : '') + ny;
        if (el.dataset.fgV !== html) {
          el.dataset.fgV = html;
          el.innerHTML = html;
        }

        /* Linje med kilopris + besparelse, direkte sammenlignbar med toppen */
        var kilo = hode.parentElement.querySelector(':scope > .fg-abo-kilo');
        var e = eske();
        var sub = tall(ny), full = tall(engang);
        var linje = '';
        if (e && sub) {
          linje = '<b class="fg-abo-kilo__pris">' + fmt(sub / e.mengde) + ' kr/' + e.enhet + '</b>';
          if (full && full > sub) linje += ' · du sparer ' + fmt(full - sub) + ' kr';
        }
        if (linje) {
          if (!kilo) {
            kilo = document.createElement('div');
            kilo.className = 'fg-abo-kilo';
            hode.insertAdjacentElement('afterend', kilo);
          }
          if (kilo.dataset.fgV !== linje) {
            kilo.dataset.fgV = linje;
            kilo.innerHTML = linje;
          }
        } else if (kilo) {
          kilo.remove();
        }

        if (!hode.dataset.fgKlikk) {
          hode.dataset.fgKlikk = '1';
          hode.addEventListener('click', function (ev) {
            var l = ev.currentTarget.parentElement.querySelector('.group_list');
            if (!l || l.querySelector('input:checked')) return;
            var forste = l.querySelector('input[type="radio"]');
            if (forste) forste.click();
          });
        }
      }
    }
  }

  var vent = null;
  function planlegg() {
    if (vent) return;
    vent = setTimeout(function () { vent = null; try { rydd(); } catch (e) {} }, 60);
  }

  function start() {
    planlegg();
    if ('MutationObserver' in window) {
      new MutationObserver(planlegg).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('change', planlegg, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
